import { createContext } from "react"
import { RootStore } from "../stores/root-store"

const RootStoreContext = createContext<RootStore>({} as RootStore)

export default RootStoreContext